import HospitalizationDetails from "./HospitalizationDetails"
import ClaimIntimatedDetails from "./ClaimIntimatedDetails"
import PatientDetails from "./PatientDetails"
import "./reviewPage.scss"
import ExistingPolicyDetails from "./ExistingPolicyDetails"
import DocumentDetails from "./DocumentDetails"
const ReviewPage = ({formData}) => {
    return <>
    <div className="review-container">
        <ClaimIntimatedDetails formData={formData} />
        <PatientDetails formData={formData} />
        <HospitalizationDetails formData={formData} />
        <ExistingPolicyDetails formData={formData} />
        <DocumentDetails formData={formData}/>
    </div>
    </>
}
export default ReviewPage